import { render, staticRenderFns } from "./LogoPageContainer.vue?vue&type=template&id=5939c8e2&scoped=true&"
import script from "./LogoPageContainer.vue?vue&type=script&lang=js&"
export * from "./LogoPageContainer.vue?vue&type=script&lang=js&"
import style0 from "./LogoPageContainer.vue?vue&type=style&index=0&id=5939c8e2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5939c8e2",
  null
  
)

export default component.exports